import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function BottomNav({ variant = 'default' }) {
  const location = useLocation();

  const items = variant === 'setup'
    ? [
        { to: '/', label: 'Home', icon: 'home' },
        { to: '/timer', label: 'Timer', icon: 'clock' },
        { to: '/help', label: 'Help', icon: 'help' },
      ]
    : [
        { to: '/', label: 'Home', icon: 'home' },
        { to: '/setup', label: 'Setup', icon: 'settings' },
        { to: '/help', label: 'Help', icon: 'help' },
      ];

  const isActive = (path) => location.pathname === path;

  const iconSvg = (name) => {
    const common = { className: 'w-8 h-8 mb-1', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' };
    switch (name) {
      case 'home':
        return (
          <svg {...common}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
        );
      case 'settings':
        return (
          <svg {...common}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        );
      case 'clock':
        return (
          <svg {...common}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
          </svg>
        );
      case 'help':
        return (
          <svg {...common}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <nav className="bg-gray-900 shadow-lg border-t border-gray-700">
      <div className="flex justify-around items-center h-16 sm:h-20">
        {items.map(({ to, label, icon }) => (
          <Link
            key={to}
            to={to}
            className={`flex flex-col items-center justify-center w-full h-full ${
              isActive(to) ? 'text-white' : 'text-gray-400'
            } hover:text-white transition-colors`}
          >
            {iconSvg(icon)}
            <span className="text-xs font-semibold">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
